import { getCurrentDateWithDay } from "@/helpers/format-date";
import { useTranslation } from "react-i18next";

import "./style.scss";

type WarningMapCardProps = {
	title: string;
	date: Date;
	color: string;
	setDate: (date: Date) => void;
	selectedDate: Date;
};

export const WarningMapCard = ({
	title,
	date,
	color,
	selectedDate,
	setDate,
}: WarningMapCardProps) => {
	const { t } = useTranslation();
	const isActive = selectedDate.toDateString() === date.toDateString();

	const { day, date: formattedDate } = getCurrentDateWithDay(date);

	return (
		<div
			className={`card ${isActive ? "active-card" : "disabled-card"}`}
			onClick={() => setDate(date)}
		>
			<div className="card-content">
				<div
					className="title-div"
					style={{ background: color === "" ? "#25B24A" : color }}
				>
					<p>{t(title)}</p>
				</div>
				<div className="date-div">
					<p>{day}</p>
					<p>{formattedDate}</p>
				</div>
			</div>

			{isActive && <span className="active-bar"></span>}
		</div>
	);
};

export default WarningMapCard;
